import { render, staticRenderFns } from "./LuckDream.vue?vue&type=template&id=07615d5c&scoped=true"
import script from "./LuckDream.vue?vue&type=script&lang=js"
export * from "./LuckDream.vue?vue&type=script&lang=js"
import style0 from "./LuckDream.vue?vue&type=style&index=0&id=07615d5c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07615d5c",
  null
  
)

export default component.exports